import { EN_DASH_DEFAULT_VALUE } from 'utils/constants/defaultValues'

/**
 * Return passed value or default value
 *
 * @param {*} value - returned value
 * @param {*} defaultValue - [–] default value
 *
 * @return {value} Example: 1) Some text; 2) true; 3) –; 4) No data;
 */
export const formatValue = (value, defaultValue = EN_DASH_DEFAULT_VALUE) =>
  value || value === 0 ? value : defaultValue
